<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>登记</h6>
      <el-button class="titBtn" type="warning" icon="el-icon-delete" @click="deleteClick">删除</el-button>
      <!-- <div class="import-s">
        <p class>
          <span class="el-icon-upload2"></span>导入
        </p>
        <input type="file" @change="xzdata($event)" />
      </div> -->
      <!-- <el-button class="titBtn" type="success" icon="el-icon-download" @click="download">模板下载</el-button> -->
      <el-button class="titBtn" type="primary" icon="el-icon-document" @click="auditing">提交审核</el-button>
      <el-button class="titBtn" type="primary" icon="el-icon-document-checked" @click="bcData">保存</el-button>
      <el-button class="titBtn" type="primary" icon="el-icon-plus" @click="xzData">新增</el-button>
      <el-button class="titBtn" type="success" icon="el-icon-search" @click="search">搜索</el-button>
      <addressTree @obj="objdata" @close="treeClose"></addressTree>
      <el-select multiple placeholder="请选择类型" v-model="ydbType" @change="ydbTypeChange" class="titBtn"
        style="width: 260px;" clearable>
        <el-option label="大型坝" value="大型"></el-option>
        <el-option label="中型坝" value="中型"></el-option>
        <el-option label="小型坝" value="小型"></el-option>
      </el-select>

      <el-select v-model="county" placeholder="请选择县" class="titBtn" clearable>
        <el-option v-for="item in xianData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>

      <el-select v-model="city" placeholder="请选择市" @change="shiChange" class="titBtn" clearable>
        <el-option v-for="item in shiData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>
      <el-select v-model="province" placeholder="请选择省" @change="shengChange" class="titBtn" clearable>
        <el-option v-for="item in shengData" :key="item.regionCode" :label="item.regionName"
          :value="item.regionCode"></el-option>
      </el-select>

    </div>
    <div class="tabBody">
      <el-table ref="multipleTable" @selection-change="handleSelectionChange"
        :header-cell-style="{ background: 'rgba(49,130,222,0.1)' }" :data="tabledata" :height="tableHeight" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" align='center' width="45" label="序号" fixed></el-table-column>
        <el-table-column prop="ydbSheng" align='center' label="省">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbSheng" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbShi" align='center' label="市">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbShi" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbXian" align='center' label="县">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbXian" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbXiang" width="120" align='center' label="乡" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbXiang"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbCun" width="120" align='center' label="村" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbCun"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbName" width="180" align='center' label="淤地坝名称" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbName"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="ydbCode" width="180" align='center' label="编码">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbCode"></el-input>
          </template>
        </el-table-column> -->
        <el-table-column prop="ydbSfwggb" width="120" align='center' label="类型" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfwggb" placeholder="请选择类型" :disabled="true">
              <el-option label="大型坝" value="大型"></el-option>
              <el-option label="中型坝" value="中型"></el-option>
              <el-option label="小型坝" value="小型"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSnzc" width="150" align='center' label="枢纽组成" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbSnzc" placeholder="请以顿号进行分隔"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSszl" align='center' label="所在流域" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbSszl"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbJcnd" width="100" align='center' label="建成年代" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbJcnd"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbKzmj" width="120" align='center' label="控制面积(km²)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbKzmj" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbBaGao" align='center' label="坝高(m)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbBaGao" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbBdcd" width="90" align='center' label="坝顶长(m)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbBdcd" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbZkr" width="110" align='center' label="总库容(万m³)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbZkr" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbDhkr" width="120" align='center' label="滞洪库容(万m³)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbDhkr" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSjyjkr" width="150" align='center' label="设计淤积库容(万m³)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbSjyjkr" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbYykr" width="120" align='center' label="已淤库容(万m³)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbYykr" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSjyjmj" width="140" align='center' label="设计淤地面积(hm²)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbSjyjmj" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbYyjmj" width="130" align='center' label="已淤地面积(hm²)" :render-header="addRedStar1">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbYyjmj" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column align='center' label="地理坐标">
          <el-table-column prop="ydbJingDu" width="140" align='center' label="经度" :render-header="addRedStar1">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbJingDu" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ydbWeiDu" width="140" align='center' label="纬度" :render-header="addRedStar1">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbWeiDu" type="number"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="ydbSfgj" width="150" align='center' label="是否改建">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfgj" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSfcxjg" width="150" align='center' label="是否除险加固">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfcxjg" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSfljb" width="150" align='center' label="是否老旧坝">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfljb" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="ydbBxsltj" width="150" align='center' label="是否病险坝">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbBxsltj" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column> -->
        <el-table-column prop="ydbSfxygzsj" width="150" align='center' label="是否需改造提升">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfxygzsj" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSfxyxsly" width="150" align='center' label="是否需蓄水利用">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfxyxsly" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSfbzyhgbyt" width="150" align='center' label="是否被占用或改变用途">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfbzyhgbyt" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align='center' label="坝体病险情况">
          <el-table-column prop="ydbBtlf" width="150" align='center' label="裂缝">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbBtlf" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbBthptt" width="150" align='center' label="滑坡坍塌">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbBthptt" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbBtcqcg" width="150" align='center' label="冲缺冲沟">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbBtcqcg" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbBtgysl" width="150" align='center' label="管涌,渗漏">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbBtgysl" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align='center' label="放水建筑物病险情况">
          <el-table-column prop="ybdFsjzwwgsj" width="150" align='center' label="卧管,竖井">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ybdFsjzwwgsj" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbFsjzwhdhg" width="150" align='center' label="涵洞,涵管">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbFsjzwhdhg" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbFsjzwmq" width="150" align='center' label="明渠">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbFsjzwmq" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align='center' label="泄水建筑物病险情况">
          <el-table-column prop="ydbXsjzwmq" width="150" align='center' label="损毁">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbXsjzwmq" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbXsjzwtsxk" width="150" align='center' label="淘刷,悬空">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbXsjzwtsxk" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbXsjzwqt" width="150" align='center' label="其他">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbXsjzwqt" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align='center' label="其他安全隐患">
          <el-table-column prop="ydbDlbt" width="150" align='center' label="道路不通">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbDlbt" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ydbLabpbwd" width="150" align='center' label="两岸边坡不稳定">
            <template slot-scope="scope">
              <el-select v-model="tabledata[scope.$index].ydbLabpbwd" placeholder="请选择是否">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="ydbYxrs" align='center' label="影响人数">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbYxrs" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbZyss" width="200" align='center' label="重要设施">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbZyss"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbJkss" width="200" align='center' label="监控设施">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbJkss"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbGlzrzt" width="100" align='center' label="管理责任主体">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbGlzrzt"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbYwghbc" align='center' label="管护报酬">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbYwghbc" type="number"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbQtwtsm" width="120" align='center' label="其他问题">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbQtwtsm"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-download" class="tableedit" round
              @click='downloadrow(scope.$index,scope.row)'></el-button> -->
        <!-- <el-button type="success" icon="el-icon-edit" circle @click="edit(scope.$index,scope.row)"
              class="btnmargin"></el-button> -->
        <!-- </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="fye">
      <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums">
      </pagintion>
    </div>
    <registerSelect v-if="registerSelectShow" @getcancel="Getcancel" @baxing="baxing"></registerSelect>
    <!-- <registerXzpopup v-if="dialogVisible == true" @cancel="registerCancel"></registerXzpopup> -->
  </div>
</template>

<script>
import addressTree from '@/components/mangement/addressTree.vue'
import pagintion from '@/components/mangement/pagintion.vue'
// import registerXzpopup from '../popup/registerXzpopup.vue'
import registerSelect from '@/components/mangement/registerSelect.vue'
import Url from '@/common/js/Url.js'
import axios from 'axios'
import {
  initRegion,
  selectRegisteredYdb,
  registeredYdb,
  deleteRegisteredYdb,
  preApproveYdb,
  getRegion
} from '@/api/api.js'
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 180,
      tabledata: [],
      total: null,
      pageSize: 20, // 每页多少条数据分页
      pageNum: 1, // 当前页
      pageNums: null,
      multipleSelection: [],
      dialogVisible: false,
      Addsid: [],
      objdata1: null,
      tabledataIndex: 0,
      isSave: false,

      radioNow: '',
      registerSelectShow: false,
      // 省市县参数
      shengData: null,
      shiData: null,
      xianData: null,
      ydbType: [],
      province: '',
      city: '',
      county: ''
    }
  },
  components: {
    addressTree,
    pagintion,
    // registerXzpopup
    registerSelect
  },
  mounted() {
    const params = {
      pageSize: this.pageSize,
      pageNum: this.pageNum,
      ydbName: this.objdata1
    }
    this.list(params)
  },
  created() {
    // 执行initRegion方法，通过接口获取省
    initRegion().then((res) => {
      this.shengData = res.sheng
      this.shiData = res.shi
      this.xianData = res.xian
    })
  },
  methods: {
    // 表头加必填符号
    addRedStar(h, {
      column
    }) {
      if (this.radioNow == '') {
        return [
          h('span', ' ' + column.label)
        ]
      } else {
        return [
          h('span', {
            style: 'color: red'
          }, '*'),
          h('span', ' ' + column.label)
        ]
      }
    },
    addRedStar1(h, {
      column
    }) {
      if (this.radioNow == '小型' || this.radioNow == '') {
        return [
          h('span', ' ' + column.label)
        ]
      } else {
        return [
          h('span', {
            style: 'color: red'
          }, '*'),
          h('span', ' ' + column.label)
        ]
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    edit(index, row) {
      this.Addsid = ['bj', row]
      this.dialogVisible = true
    },
    downloadrow(index, row) {
      window.location.href = '/userApi/ydb/basic/downYdbInfo?id=' + row.id
    },
    treeClose() {
      this.objdata1 = null
      this.total = null
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    search() {
      this.tabledata = []
      this.total = null
      this.pageSize = 20
      this.pageNum = 1
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1,
        ydbShengCode: this.province == '' ? null : this.province,
        ydbShiCode: this.city == '' ? null : this.city,
        ydbXianCode: this.county == '' ? null : this.county,
        ydbSfwggbs: this.ydbType.length == 0 ? [] : this.ydbType
      }
      this.list(params)
    },

    objdata(data) {
      this.objdata1 = data
    },
    DsyData(data) { // 多少页
      this.pageNum = data.dsy
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    DstData(data) { // 多少条
      this.pageSize = data.dst
      const params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    download() {
      window.location.href = '/userApi/ydb/basic/export'
    },

    list(params) {
      this.tabledata = []
      selectRegisteredYdb(params).then((res) => {
        // console.log(res.data)
        this.total = res.total
        this.tabledata = res.data
      })
    },
    deleteClick(index, rows) {
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要删除的数据！',
          type: 'success'
        })
      } else {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            const ids = []
            const ids1 = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
              if (this.multipleSelection[i].id) {
                ids.push(this.multipleSelection[i].id)
                deleteRegisteredYdb(ids).then((res) => { })
                this.tabledata = this.tabledata.filter(function (item) {
                  return ids.indexOf(item.id) < 0
                })
              } else {
                ids1.push(this.multipleSelection[i].tabledataIndex)
                this.tabledata = this.tabledata.filter(function (item) {
                  return ids1.indexOf(item.tabledataIndex) < 0
                })
              }
            }
          }
        }).catch(() => { })
      }
    },

    xzdata(e) {
      const file = e.target.files[0]
      const filename = file.name.split('.')[
        file.name.split('.').length - 1
      ]

      const filenames = file.name
      const fileSize = file.size / 1024 / 1024 < 1000000

      if (fileSize) {
        if (filename != 'xlsx') {
          this.$notify({
            title: '提示',
            message: '请选择xls文件',
            type: 'success'
          })
          e.target.value = null
        } else {
          const formData = new FormData()
          formData.append('file', file)
          /* formData.append("importFile", file);
            formData.append("no", this.treeno);
            formData.append("proId", this.proID); */
          const config = {
            headers: {
              'Content-Type': 'multipart/form-data'
              // "login-token": this.$store.state.logintoken,
            }
          } // 添加请求头

          axios.post('/importfile/ydb/basic/import', formData, config).then((res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: '提示',
                message: res.data.message,
                type: 'success'
              })
              const params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              }
              this.list(params)
              e.target.value = null
            } else {
              this.$notify({
                title: '提示',
                message: res.data.message,
                type: 'warning'
              })
            }
          }).catch((err) => { })
        }
      } else {
        this.$message({
          message: '文件不能大于10M',
          type: 'success'
        })
        e.target.value = null
      }
    },

    // 新增一条记录
    xzData() {
      console.log(this.tabledata)
      this.registerSelectShow = true
      this.radioNow = ''
    },

    // 提交审核
    auditing() {
      // console.log("提交审核")
      const _this = this
      if (this.isSave == false) {
        this.$notify({
          title: '提示',
          message: '请先进行数据保存！',
          type: 'warning'
        })
      } else {
        if (this.multipleSelection.length == 0) {
          this.$notify({
            title: '提示',
            message: '请选择要提交审核的数据！',
            type: 'warning'
          })
        } else {
          preApproveYdb(this.multipleSelection).then((res) => {
            if (res.code == 200) {
              this.$notify({
                title: '提示',
                message: '提交审核成功！',
                type: 'success'
              })
              const params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              }
              this.list(params)
              this.isSave = false
            } else {
              this.$notify({
                title: '提示',
                message: '提交审核失败！',
                type: 'error'
              })
            }
          })
        }
      }
    },

    // 保存
    bcData() {
      // console.log("保存", this.multipleSelection)
      const _this = this
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要保存的数据！',
          type: 'warning'
        })
      } else {
        let issave = true
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (this.multipleSelection[i].ydbSfwggb == '小型') {
            if (this.multipleSelection[i].ydbXiang && this.multipleSelection[i].ydbCun && this
              .multipleSelection[i].ydbName && this.multipleSelection[i].ydbSfwggb && this
                .multipleSelection[i].ydbSnzc && this.multipleSelection[i].ydbSszl && this
                  .multipleSelection[i].ydbJcnd) {
              issave = true
            } else {
              issave = false
            }
          } else {
            if (this.multipleSelection[i].ydbXiang && this.multipleSelection[i].ydbCun && this
              .multipleSelection[i].ydbName && this.multipleSelection[i].ydbSfwggb && this
                .multipleSelection[i].ydbSnzc && this.multipleSelection[i].ydbSszl && this
                  .multipleSelection[i].ydbJcnd && this.multipleSelection[i].ydbKzmj && this.multipleSelection[
                    i].ydbBaGao && this.multipleSelection[i].ydbBdcd && (this.multipleSelection[i].ydbZkr || this
                      .multipleSelection[i].ydbZkr == 0) && (this.multipleSelection[i].ydbDhkr || this.multipleSelection[i].ydbDhkr == 0) &&
              (this.multipleSelection[i].ydbSjyjkr || this.multipleSelection[i].ydbSjyjkr == 0) &&
              (this.multipleSelection[i].ydbYykr || this.multipleSelection[i].ydbYykr == 0) &&
              (this.multipleSelection[i].ydbSjyjmj || this.multipleSelection[i].ydbSjyjmj == 0) &&
              (this.multipleSelection[i].ydbYyjmj || this.multipleSelection[i].ydbYyjmj == 0) &&
              this.multipleSelection[i].ydbJingDu && this.multipleSelection[i].ydbWeiDu) {
              issave = true
            } else {
              issave = false
            }
          }
          this.multipleSelection[i].ydbBxsltj = Number(this.multipleSelection[i].ydbBtlf) + Number(this
            .multipleSelection[i].ydbBthptt) + Number(this
              .multipleSelection[i].ydbBtcqcg) + Number(this.multipleSelection[i].ydbBtgysl) + Number(this
                .multipleSelection[i].ybdFsjzwwgsj) + Number(this
                  .multipleSelection[i].ydbFsjzwhdhg) + Number(this.multipleSelection[i].ydbFsjzwmq) + Number(this
                    .multipleSelection[i].ydbXsjzwmq) + Number(this
                      .multipleSelection[i].ydbXsjzwtsxk) + Number(this.multipleSelection[i].ydbXsjzwqt) + Number(this
                        .multipleSelection[i].ydbDlbt) + Number(
                          this.multipleSelection[i].ydbLabpbwd)
        }
        if (issave == true) {
          registeredYdb(this.multipleSelection).then((res) => {
            if (res.code == 200) {
              _this.$notify({
                title: '提示',
                message: '保存成功!',
                type: 'success'
              })
              _this.isSave = true
              const params = {
                pageSize: _this.pageSize,
                pageNum: _this.pageNum,
                ydbName: _this.objdata1
              }
              _this.list(params)
            } else {
              _this.$notify({
                title: '提示',
                message: res.message,
                type: 'error'
              })
            }
          })
        } else {
          _this.$notify({
            title: '提示',
            message: '有必填项未填',
            type: 'warning'
          })
        }
      }
    },

    baxing(type) {
      const _this = this
      this.registerSelectShow = false
      this.radioNow = type
      this.tabledataIndex += 1
      initRegion().then((res) => {
        // console.log(res)
        if (res.sheng[0] && res.shi[0] && res.xian[0]) {
          _this.tabledata.push({
            tabledataIndex: _this.tabledataIndex,
            ydbSheng: res.sheng[0].regionName,
            ydbShengCode: res.sheng[0].regionCode,
            ydbShi: res.shi[0].regionName,
            ydbShiCode: res.shi[0].regionCode,
            ydbXian: res.xian[0].regionName,
            ydbXianCode: res.xian[0].regionCode,
            ydbXiang: '',
            ydbCun: '',
            ydbName: '',
            ydbCode: '',
            ydbSfwggb: this.radioNow,
            ydbSnzc: '',
            ydbSszl: '',
            ydbJcnd: '',
            ydbKzmj: '',
            ydbBaGao: '',
            ydbBdcd: '',
            ydbZkr: '',
            ydbDhkr: '',
            ydbSjyjkr: '',
            ydbYykr: '',
            ydbSjyjmj: '',
            ydbYyjmj: '',
            ydbJingDu: '',
            ydbWeiDu: '',
            ydbSfgj: '',
            ydbSfcxjg: '',
            ydbSfljb: '',
            ydbBxsltj: '',
            ydbSfxygzsj: '',
            ydbSfxyxsly: '',
            ydbSfbzyhgbyt: '',
            ydbBtlf: '0',
            ydbBthptt: '0',
            ydbBtcqcg: '0',
            ydbBtgysl: '0',
            ybdFsjzwwgsj: '0',
            ydbFsjzwhdhg: '0',
            ydbFsjzwmq: '0',
            ydbXsjzwmq: '0',
            ydbXsjzwtsxk: '0',
            ydbXsjzwqt: '0',
            ydbDlbt: '0',
            ydbLabpbwd: '0',
            ydbYxrs: 0,
            ydbZyss: '',
            ydbJkss: '',
            ydbGlzrzt: '',
            ydbYwghbc: '',
            ydbQtwtsm: '',
            ydbLx: '登记'
          })
        } else {
          this.$notify({
            title: '提示',
            message: '您没有权限新增记录！',
            type: 'warning'
          })
        }
      })
    },

    Getcancel(data) {
      this.registerSelectShow = false
    },
    shengChange() {
      if (Array.isArray(this.shiData) && this.shiData.length != 0) {
        this.city = ''
        this.county = ''
        this.shiData = null
        this.xianData = null
      }
      const params = {
        regionCode: this.province
      }
      getRegion(params).then((res) => {
        this.shiData = res.data
      })
    },
    shiChange() {
      if (Array.isArray(this.xianData) && this.xianData.length != 0) {
        this.county = ''
        this.xianData = null
      }
      const params = {
        regionCode: this.city
      }
      getRegion(params).then((res) => {
        this.xianData = res.data
      })
    },
    ydbTypeChange(value) {
      this.ydbLx = value
    }
  }
}
</script>

<style scoped>
  @import url('../../../common/css/mangementall.css');

  .zblxtree {
    width: 230px;
    height: calc(100% - 80px);
    height: -webkit-calc(100% - 80px);
    height: -moz-calc(100% - 80px);
    background: #f7f7f7;
    border-radius: 6px;
    float: left;
    overflow: auto;
    padding: 15px;
  }

  .zblxtreeSty {
    background: #f7f7f7;
    border-radius: 6px;
  }

  .tablelist {
    width: 100%;
    height: calc(100% - 50px);
    height: -webkit-calc(100% - 50px);
    height: -moz-calc(100% - 50px);
    float: right;
    position: relative;
  }

  .tablelistbox {
    width: 100%;
    heigt: 100%;
  }

  .clsjTis {
    position: absolute;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    margin: auto;
    width: 335px;
    height: 210px;
    border: 1px solid #cccccc;
    background: #f7f7f7;
    border-radius: 6px;
    font-size: 16px;
  }

  .ycllxname {
    float: left;
    line-height: 30px;
    font-size: 14px;
    margin-left: 10px;
    margin-top: 10px;
  }

  .cllx-select {
    float: left;
    margin-top: 10px;
    width: 230px;
  }

  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  .zzct {
    font-size: 20px;
    margin-right: 10px;
  }

  .import-s {
    float: right;
    position: relative;
    width: 100px;
    height: 28px;
    background: #409eff;
    margin-right: 10px;
    border-radius: 4px;
    margin-top: 11px;
    overflow: hidden;
  }

  .import-s p {
    position: absolute;
    width: 100%;
    line-height: 28px;
    text-align: center;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
  }

  .import-s p span {
    margin-right: 5px;
  }

  .import-s input {
    width: 100%;
    height: 28px;
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  >>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #606266;
    font-size: 14px;
    padding: 0;
    padding-left: 5px;
  }
</style>
